export interface HrActionTypes {
  type: HrActions;
  payload?: any;
}

export enum HrActions {
  GET_DAILY_ATTENDANCE_LIST = "GET_DAILY_ATTENDANCE_LIST",
  GET_MY_DAILY_ATTENDANCE_LIST = "GET_MY_DAILY_ATTENDANCE_LIST",
  GET_MY_REGULARIZATION_LIST = "GET_MY_REGULARIZATION_LIST",
  GET_REGULARIZATION_LIST = "GET_REGULARIZATION_LIST",
  GET_REGULARIZATION_BY_ID = "GET_REGULARIZATION_BY_ID",

  SET_DAILY_ATTENDANCE_LIST = "SET_DAILY_ATTENDANCE_LIST",
  SET_MY_DAILY_ATTENDANCE_LIST = "SET_MY_DAILY_ATTENDANCE_LIST",
  SET_MY_REGULARIZATION_LIST = "SET_MY_REGULARIZATION_LIST",
  SET_REGULARIZATION_LIST = "SET_REGULARIZATION_LIST",

  SET_DAILY_ATTENDANCE_PAGE_COUNT = "SET_DAILY_ATTENDANCE_PAGE_COUNT",
  SET_MY_DAILY_ATTENDANCE_PAGE_COUNT = "SET_MY_DAILY_ATTENDANCE_PAGE_COUNT",
  SET_MY_REGULARIZATION_PAGE_COUNT = "SET_MY_REGULARIZATION_PAGE_COUNT",
  SET_REGULARIZATION_PAGE_COUNT = "SET_REGULARIZATION_PAGE_COUNT",
  SET_REGULARIZATION_DATA = "SET_REGULARIZATION_DATA",

  GET_ATTENDANCE_REPORT = "GET_ATTENDANCE_REPORT",

  USER_CHECK_IN = "USER_CHECK_IN",
  SET_USER_CHECK_IN = "SET_USER_CHECK_IN",
  SET_USER_CHECK_OUT = "SET_USER_CHECK_OUT",
  USER_CHECK_OUT = "USER_CHECK_OUT",

  GET_ACTIVITY = "GET_ACTIVITY",
  SET_ACTIVITY = "SET_ACTIVITY",

  SET_LEAVE_STATUS = "SET_LEAVE_STATUS",
  GET_LEAVE_LIST = "GET_LEAVE_LIST",
  SET_LEAVE_LIST = "SET_LEAVE_LIST",
  SET_LEAVE_LIST_PAGE_COUNT = "SET_LEAVE_LIST_PAGE_COUNT",
  GET_LEAVE_BY_ID = "GET_LEAVE_BY_ID",
  SET_LEAVE_DATA = "SET_LEAVE_DATA",
  EDIT_LEAVE = "EDIT_LEAVE",
  APPLY_LEAVE = "APPLY_LEAVE",
  
  GET_MY_LEAVE_LIST = "GET_MY_LEAVE_LIST",
  SET_MY_LEAVE_LIST = "SET_MY_LEAVE_LIST",
  SET_MY_LEAVE_LIST_PAGE_COUNT = "SET_MY_LEAVE_LIST_PAGE_COUNT",

  APPLY_REGULARIZATION = "APPLY_REGULARIZATION",
  EDIT_REGULARIZATION = "EDIT_REGULARIZATION",

  // Holidays
  CREATE_HOLIDAY = "CREATE_HOLIDAY",
  GET_HOLIDAY_LIST = "GET_HOLIDAY_LIST",
  SET_HOLIDAY_LIST = "SET_HOLIDAY_LIST",
  GET_HOLIDAY_BY_ID = "GET_HOLIDAY_BY_ID",
  SET_HOLIDAY_DATA = "SET_HOLIDAY_DATA",
  SET_HOLIDAY_LIST_PAGE_COUNT = "SET_HOLIDAY_LIST_PAGE_COUNT",
  EDIT_HOLIDAY = "EDIT_HOLIDAY",
}